<template>
  <p v-for="(texte, i) in conseils" :key="i" class="question-conseil" role="status">
    <i class="fas fa-comment-dots" aria-hidden="true"></i>
    <span>{{ texte }}</span>
  </p>
</template>

<script setup>
import { computed } from 'vue'
import { conseilsPourReponses } from '../../utils/conseilsQuestions.js'

/**
 * Conseils affichés sous une question, selon ce que le client a répondu.
 *
 * Un composant plutôt qu'un bloc recopié : la même feuille était rendue par les
 * deux écrans de réponse et l'aperçu, avec des couleurs en dur d'un côté et les
 * variables du projet de l'autre — le même conseil n'avait donc pas la même
 * apparence selon l'écran.
 *
 * `reponses` accepte les deux formes rencontrées : un tableau (cases à cocher)
 * ou une valeur seule (réponse unique).
 */
const props = defineProps({
  regles: { type: Array, default: () => [] },
  reponses: { type: [Array, String, Number], default: null },
})

const conseils = computed(() => {
  const retenues = Array.isArray(props.reponses)
    ? props.reponses
    : props.reponses
      ? [props.reponses]
      : []
  return conseilsPourReponses(props.regles, retenues)
})
</script>

<style scoped>
.question-conseil {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-xs);
  margin: var(--spacing-xs) 0 0;
  padding: var(--spacing-sm);
  border-left: 3px solid var(--color-primary);
  border-radius: var(--radius-sm);
  background: var(--color-primary-lightest);
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.question-conseil i {
  margin-top: 2px;
  color: var(--color-primary);
}
</style>
